/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeySecretPkcs8: core.serialization.Schema<serializers.KeySecretPkcs8.Raw, Truvity.KeySecretPkcs8> =
    core.serialization.string();

export declare namespace KeySecretPkcs8 {
    export type Raw = string;
}
